import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Hor_header from "../header/hor_header";
import Ver_header from "../header/ver_header";
import Footer from "../footer/footer";
import swal from "sweetalert";
import { API_URL } from "../constant";
import Loader from "./loading";
import { reactLocalStorage } from "reactjs-localstorage";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.flash";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "datatables.net-responsive";

import $ from 'jquery';

import ResetModal from "./resetPasswordModel";



function AllStoreList() {

  const navigat = useNavigate();

  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [showLogin, setShowLogin] = useState(false);
  const [mobid, setMobid] = useState();

useEffect(() => {
         if(localStorage.getItem("userLoginType")=='Chc'){
              return navigat('/');
         } 
     },[1])



  $('#example').DataTable().destroy();

  $(document).ready(function () {


    $('#example').DataTable({
      destroy: true,
      'aoColumnDefs': [{
        'bSortable': false,
        'aTargets': ['nosort']
      }],
      dom: 'Bfrtip',
      buttons: ['copy', 'csv', 'excel', 'pdf', 'print'],
      responsive: true
    });
  });

  useEffect(() => {
    document.title = "All CHC";
    getAllUsersData();
  }, []
  );
  /************Get all register user********************** */
  let getAllUsersData = async () => {

    // const res = await axios.get(API_URL + 'chc/getAllRegisteredStore')
    //   .then(ress => {
    //     setUserData(ress.data.Rdata);
    //     setIsLoading(false);
    //   });
     
      if (reactLocalStorage.get('userLoginType') == 'Admin') {
            const res = await axios.post(API_URL + 'chc/getAllRegisteredStore')
              .then(ress => {
                setUserData(ress.data.Rdata);
                setIsLoading(false);
              });
          } else {
      
          const  datas = { "userType": reactLocalStorage.get("userType"), "userLoginType": reactLocalStorage.get("userLoginType") } 
            const res = await axios.post(API_URL + 'chc/getAllRegisteredStoreForParticular', datas)
              .then(ress => {
                setUserData(ress.data.Rdata);
                setIsLoading(false);
              });
          }

  }





  /******************Delete user****************************** */
  let deleteData = async (vals) => {
    const dataDel = { "user_id": vals };

    const res = await axios.post(API_URL + 'chc/deleteData', dataDel)
      .then(ress => {
        if (ress.status == "200") {
          swal("User Deleted");
        } else {
          swal("Some error occured, please try after some time. ");
        }
        getAllUsersData();

      });

  }
  /************Update CHC Activation status ********************** */
  let updateStatus = async (vals, status) => {
    const dataStatusUpdate = { 'user_id': vals, 'status': status }
    const res = await axios.post(API_URL + 'chc/updateChcStatus', dataStatusUpdate)
      .then(ress => {
        if (ress.status == '200') {
          swal("Status Changed.");
          getAllUsersData();
        }

      });

  }
  /******************Redirecting to edit page***************************** */
  let editUser = (data,mob, stateId,disId,blockId,chcId) => {
   
    return navigat('/edit-store-list/' + data + '/' +mob + '/'+ stateId + '/'+disId + '/'+blockId + '/' + chcId);
  }


  return (

    <div className="container-scroller">

      <Hor_header />

      <div className="container-fluid page-body-wrapper">

        <Ver_header />

        <div className="main-panel">
          {isLoading ? (<Loader />) : (
            <>
              <div className="content-wrapper">
                <div className="row">


                  <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="card-title">All DH/SDH/CHC Store User Lists</h4>

                        <div className="table-responsive pt-3">
                          
                          <table className="table table-bordered display  nowrap" id="example">
                            <thead>
                              <tr>
                               
                                <th className="nosort"></th>
                                <th> Status </th>
                                <th className="nosort"> Action </th>
                                <th> DH/SDH/CHC </th>
                                <th> User Type </th>
                               
                                <th> Mobile </th>
                                <th> Block </th>
                                <th> District </th>
                             
                              </tr>
                            </thead>
                            <tbody>

                              {userData.map((udata, index) => (
                                <tr key={index} >
                                  <td></td>
                                  <td>
                                    <button className={udata.status ? 'btn btn-success btn-sm cust_btn' : 'btn btn-danger btn-sm cust_btn'} onClick={() => { if (window.confirm(udata.status ? 'Are you sure to Inactivate Storekeeper?' : 'Are you sure to Activate Storekeeper?')) { updateStatus(udata.user_id, udata.status ? '0' : '1') } }}  >{udata.status ? 'Active' : 'Inactive'}</button>
                                  </td>

                                  <td>
                                    <button type="button" className="btn btn-outline-secondary btn-rounded btn-icon" title="Delete Storekeeper" onClick={() => { if (window.confirm('Delete the item?')) { deleteData(udata.user_id) } }} disabled>
                                      <i className="typcn typcn-trash text-success"></i>
                                    </button>

                                    <button type="button" className="btn btn-outline-secondary btn-rounded btn-icon" title="Edit Storekeeper" onClick={() => { editUser(udata.user_id,udata.mobile_no,udata?.state_id, udata?.district_id, udata?.block_id, udata?.chc_phc_id) }}>
                                      <i className="typcn typcn-edit  text-primary"></i>
                                    </button>
                                    <button type="button" className="btn btn-outline-secondary btn-rounded btn-icon" title="Reset password" onClick={() => { setShowLogin(true); setMobid(udata.mobile_no); }}>
                                      <i className="typcn typcn-key-outline  text-warning"></i>
                                    </button>


                                  </td>
                                  <td> {udata.chc_name} </td>
                                  <td> {udata.user_type != null ? udata.user_type.toUpperCase() : ""}</td>
                                 
                                  <td> {udata.mobile_no}</td>
                                  <td> {udata.block_name}</td>
                                  <td> {udata.district_name} </td>
                                
                                </tr>

                              ))}

                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                  </div>

                  <ResetModal show={showLogin} data={mobid} close={() => setShowLogin(false)} />

                </div>
              </div>

              <Footer />
            </>
          )}
        </div>

      </div>

    </div>




  );

}

export default AllStoreList;